var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import { useAtom } from "jotai";
import { useAtomValue, useUpdateAtom } from "jotai/utils";
import React, { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { CurrentSheetAtom, PagesAtom, PageSelectorVisible, useFullScreen, Zoom, } from "@/atoms";
import styles from "./ArtbookControls.module.scss";
import { IconButton, IconTheme } from "@/components/IconButton/IconButton";
import { getPageNumber, getSheetIndexFromPageNumber, SheetSide, } from "@/utils/pages";
import { IconMenu } from "../IconButton/IconMenu";
import { PagesPreview } from "@/components/PagePreview/PagesPreview";
import { CONFIG } from "@/config";
import { metrics } from "../../analytics/events";
import { SfxControl } from "@/components/ArtbookControls/SoundtrackControls";
export function PlayerControls(props) {
    var _a = __read(useAtom(Zoom), 2), zoom = _a[0], setZoom = _a[1];
    var pages = useAtomValue(PagesAtom);
    var _b = __read(useAtom(CurrentSheetAtom), 2), sheet = _b[0], setSheet = _b[1];
    var leftPage = getPageNumber(sheet, SheetSide.back);
    var _c = useFullScreen(), toggleFullscreen = _c.toggleFullscreen, fullscreenEnabled = _c.enabled;
    var setPageSelectorVisible = useUpdateAtom(PageSelectorVisible);
    return (React.createElement("div", { className: classNames(styles.controlPanel, styles.groupPlayer) },
        React.createElement("div", { className: styles.buttonGroup },
            React.createElement(IconButton, { icon: require("@/public_assets/button_home.png"), iconHover: require("@/public_assets/button_home_hover.png"), onClick: function () {
                    setSheet(-1);
                    metrics.clickOnNavigationSummary();
                }, theme: IconTheme.Dark, iconSize: "small", tooltip: {
                    position: "top",
                    label: React.createElement(FormattedMessage, { defaultMessage: "summary", id: "u93pr8" }),
                } }),
            React.createElement(IconButton, { icon: require("@/public_assets/button_arrow_left.png"), iconHover: require("@/public_assets/button_arrow_left_hover.png"), onClick: function () {
                    setSheet("prev");
                    metrics.clickOnNavigationLeftArrow();
                }, theme: IconTheme.Dark, tooltip: {
                    position: "top",
                    label: (React.createElement(FormattedMessage, { defaultMessage: "previous page", id: "xfrRMu" })),
                } }),
            React.createElement("div", { className: styles.pageControl },
                React.createElement(IconMenu, { icon: require("@/public_assets/button_summary.png"), iconHover: require("@/public_assets/button_summary_hover.png"), arrow: true, menu: {
                        holderClass: styles.pagesPreviewMenu,
                        class: styles.pagesPreviewMenuContent,
                        content: function (close) { return (React.createElement(PagesPreview, { onSelectSheet: function (sheet) {
                                metrics.clickOnPreviewThumbnail(sheet);
                                setSheet(sheet);
                                close();
                            } })); },
                        position: "top",
                        size: "large",
                    }, theme: IconTheme.Transparent, tooltip: {
                        position: "top",
                        label: (React.createElement(FormattedMessage, { defaultMessage: "preview pages", id: "97g8rg" })),
                    }, onToggle: function (visible) {
                        setPageSelectorVisible(visible);
                        if (visible) {
                            metrics.clickOnSeeAllPage();
                            metrics.onPreviewVisible();
                        }
                    } }),
                React.createElement("span", null,
                    React.createElement("span", { className: styles.currentPage },
                        React.createElement(SpanNumberInput, { value: leftPage, onValueChange: function (p) { return setSheet(getSheetIndexFromPageNumber(p)); } }),
                        "-",
                        React.createElement(SpanNumberInput, { value: leftPage + 1, onValueChange: function (p) { return setSheet(getSheetIndexFromPageNumber(p)); } })),
                    "/",
                    pages.getPageCount() + CONFIG.pages.firstPageNumber - 1)),
            React.createElement(IconButton, { icon: require("@/public_assets/button_arrow_right.png"), iconHover: require("@/public_assets/button_arrow_right_hover.png"), onClick: function () {
                    setSheet("next");
                    metrics.clickOnNavigationRightArrow();
                }, theme: IconTheme.Dark, tooltip: {
                    position: "top",
                    label: React.createElement(FormattedMessage, { defaultMessage: "next page", id: "rrDA7T" }),
                } }),
            React.createElement(IconButton, { icon: require("@/public_assets/button_zoom_out.png"), iconHover: require("@/public_assets/button_zoom_out_hover.png"), onClick: function () {
                    setZoom(zoom - 0.2);
                    metrics.clickOnZoomOut();
                }, theme: IconTheme.Dark, tooltip: {
                    position: "top",
                    label: React.createElement(FormattedMessage, { defaultMessage: "zoom out", id: "rO8cOT" }),
                } }),
            React.createElement(IconButton, { icon: require("@/public_assets/button_zoom_in.png"), iconHover: require("@/public_assets/button_zoom_in_hover.png"), onClick: function () {
                    setZoom(zoom + 0.2);
                    metrics.clickOnZoomIn();
                }, theme: IconTheme.Dark, tooltip: {
                    position: "top",
                    label: React.createElement(FormattedMessage, { defaultMessage: "zoom in", id: "uDqwuU" }),
                } }),
            React.createElement(IconButton, { icon: fullscreenEnabled
                    ? require("@/public_assets/button_window.png")
                    : require("@/public_assets/button_fullscreen.png"), iconHover: fullscreenEnabled
                    ? require("@/public_assets/button_window_hover.png")
                    : require("@/public_assets/button_fullscreen_hover.png"), className: styles.fullscreenButton, onClick: toggleFullscreen, theme: IconTheme.Dark, tooltip: {
                    position: "top",
                    label: fullscreenEnabled ? (React.createElement(FormattedMessage, { defaultMessage: "leave fullscreen", id: "gGIFmJ" })) : (React.createElement(FormattedMessage, { defaultMessage: "fullscreen", id: "EV6pqb" })),
                } }),
            props.sfxControl && React.createElement(SfxControl, { tooltipPosition: "top" }))));
}
function SpanNumberInput(_a) {
    var value = _a.value, onValueChange = _a.onValueChange, props = __rest(_a, ["value", "onValueChange"]);
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current == null)
            return;
        ref.current.innerText = value.toString();
    }, [value]);
    function reset() {
        if (ref.current == null)
            return;
        ref.current.innerText = value.toString();
    }
    return (React.createElement("span", __assign({}, props, { ref: ref, contentEditable: true, onKeyDown: function (e) {
            e.stopPropagation();
            if (!(e.key.match(/^\d$/) ||
                e.key === "ArrowLeft" ||
                e.key === "ArrowRight" ||
                e.key === "Backspace" ||
                e.key === "Delete")) {
                e.preventDefault();
            }
            if (e.key === "Enter") {
                e.currentTarget.blur();
            }
        }, onFocus: function (e) {
            var selection = window.getSelection();
            if (selection == null)
                return;
            var range = document.createRange();
            range.selectNodeContents(e.currentTarget);
            selection.removeAllRanges();
            selection.addRange(range);
        }, onBlur: function (e) {
            var p = parseInt(e.currentTarget.textContent || "");
            reset();
            if (!isNaN(p)) {
                onValueChange(p);
            }
        } })));
}
